import { useAuthError } from '~/stores/error.store.ts'

export function useError() {
  const store = useAuthError()
  function showError(description: string, title?: string): void {
    store.setError(description, title)
  }
  return {
    showError
  }
}
